import React, { useState, useEffect } from 'react';

import { Grid, CssBaseline } from '@material-ui/core';
import { AboutPageNavbar } from 'components/aboutPageNavbar/aboutPageNavbar';

import { Box } from '@material-ui/core';
import { useAboutPageStyles } from './style';

import { Fab } from '@material-ui/core/';
import AddIcon from '@material-ui/icons/Add';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

import 'react-quill/dist/quill.bubble.css';
import { validateToken } from 'stores/auth/actions';
import { getJwtTokenStorageKey } from 'config/localStorage';
import {
  getNewsItems,
  createNewsItem,
  updateNewsItem,
  deleteNewsItem,
} from '../../api/news/newsApi';
import NewsCard from 'pages/home/newsCard';
import { ScrollTop } from 'pages/home/scrollTop';

function AboutPage() {
  const classes = useAboutPageStyles();
  const JWT_TOKEN_STORAGE_NAME = getJwtTokenStorageKey();
  const token = localStorage.getItem(JWT_TOKEN_STORAGE_NAME);
  const decodedToken = validateToken(token);
  const isAdmin = decodedToken && (decodedToken.roles || []).includes('Admin');
  const [counter, setCounter] = useState(0);
  const [newsItems, setNewsItems] = useState([]);

  const onChange = (value, newsItem) => {
    const { newsItemId } = newsItem || {};

    if (newsItemId) {
      const updatedNewsItem = { content: value, newsItemId };
      const updatedNewsItems = newsItems.map(item => {
        return item.newsItemId === newsItemId ? updatedNewsItem : item;
      });
      setNewsItems(updatedNewsItems);
    }
  };

  useEffect(() => {
    (async function getNews() {
      const theNews = await getNewsItems('organization');
      if (theNews.data) setNewsItems(theNews.data);
    })();
  }, [counter]);

  const handleSave = newsItem => {
    const { newsItemId, content, publicationDate, sortOrder, editorType } = newsItem || {};
    // optionally update the publicationdate
    const itemData = { newsItemId, content, publicationDate, sortOrder, editorType };
    const updatedNewsItems = newsItems.map(item => {
      return item.newsItemId === newsItemId ? itemData : item;
    });
    setNewsItems(updatedNewsItems);
    updateNewsItem(itemData);
  };

  const handleClickAdd = () => {
    (async function getNews() {
      await createNewsItem({ content: '', publicationDate: new Date(), topic: 'organization' });
      setCounter(counter + 1);
    })();
  };

  const handleDelete = newsItem => {
    (async function getNews() {
      await deleteNewsItem(newsItem.newsItemId);
      setCounter(counter + 1);
    })();
  };

  const topAnchor = 'officiating-app-bar';

  return (
    <Grid container direction='column'>
      <CssBaseline />
      <AboutPageNavbar selectedIndex={1} />
      <Box m={3} className={classes.root}>
        {newsItems
          .sort(
            (a, b) =>
              a.sortOrder - b.sortOrder ||
              new Date(b.publicationDate) - new Date(a.publicationDate),
          )
          .map((newsItem, i) => (
            <NewsCard
              onChange={onChange}
              handleSave={handleSave}
              handleDelete={handleDelete}
              alwaysExpanded={true}
              newsItem={newsItem}
              isAdmin={isAdmin}
              key={i + 1}
            />
          ))}
        {!isAdmin ? (
          <ScrollTop topAnchor={topAnchor}>
            <Fab color='secondary' size='small' aria-label='scroll back to top'>
              <KeyboardArrowUpIcon />
            </Fab>
          </ScrollTop>
        ) : (
          <Fab className={classes.addNewsItem} color='secondary' size='small' aria-label='add'>
            <AddIcon onClick={handleClickAdd} />
          </Fab>
        )}
      </Box>
    </Grid>
  );
}

export default AboutPage;
